export const actionTypes = {
  fetch:          '[USER] Fetch Profile',
  fetchSuccess:   '[USER] Fetch Profile Success',
  fetchFail:      '[USER] Fetch Profile Fail',
  update:         '[USER] Update Profile',
  updateSuccess:  '[USER] Update Profile Success',
  updateFail:     '[USER] Update Profile Fail'
}

const fetch = () => ({
  type: actionTypes.fetch
})

const fetchSuccess = payload => ({
  type: actionTypes.fetchSuccess,
  payload
})

const fetchFail = payload => ({
  type: actionTypes.fetchFail,
  payload
})

const update = (payload) => ({
  type: actionTypes.update,
  payload
})

const updateSuccess = (payload) => ({
  type: actionTypes.updateSuccess,
  payload
})

const updateFail = (payload) => ({
  type: actionTypes.updateFail,
  payload
})

export const actions = {
  fetch,
  fetchSuccess,
  fetchFail,
  update,
  updateSuccess,
  updateFail
}



// WEBPACK FOOTER //
// ./src/features/Settings/profile/store/actions.js